export default "__VITE_ASSET__Pto4yubk__"